import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { AppEnvironmentService } from './app.environment.service';

@Injectable()
export class MixpanelService {
  private mixpanelToken: string;

  /**
   * constructor
   * get mixpanel token and initialize
   */
  constructor(private env: AppEnvironmentService) {
    this.mixpanelToken = this.env.mixPanel;
    this.init();
  }

  /**
   * Initialize mixpanel.
   */
  init(): void {
    mixpanel.init(this.mixpanelToken, {
      secure_cookie: true,
      persistence: 'localStorage',
    });
  }

  /**
   * Create new Alias for user
   * Call this method only once in user lifecycle
   *
   * @param {string} alias
   */
  createAlias(alias: string): void {
    mixpanel.alias(alias, mixpanel.get_distinct_id());
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {
    mixpanel.track(id, action);
  }

  /**
   * setup mixpannel
   *
   */
  setup(): void {
    // mixpanel.loggingEnabled = false;
    this.setSuperProperties({ Platform: 'web' });
  }

  /**
   * setSuperProperties
   *
   * @param {object} properties
   */
  setSuperProperties(properties): void {
    mixpanel.register(properties);
  }

  /**
   * sendEvent
   *
   * @param {string} event
   * @param {object} properties
   */
  sendEvent(event: string, properties?): void {
    if (properties) {
      mixpanel.track(event, properties);
    } else {
      this.trackEvent(event);
    }
  }

  /**
   * trackEvent
   * @param {string} event
   */
  trackEvent(event: string): void {
    mixpanel.track(event);
  }

  /**
   * Reset Mixpanel
   */
  logout(): void {
    mixpanel.reset();
  }
}
